<!--Two column block-->
<template>
    <v-card tile height="100%" class="pa-0 ma-0" outlined color="transparent">
        <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;" :key="video.video_id">
            <div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><iframe :src="defaultWistiaVideo" :title="title" allow="autoplay; fullscreen" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" msallowfullscreen width="50%" height="50%" :key="video_id"></iframe></div>
        </div>
    </v-card>
</template>
<script>
import QuilityAPI from '@/store/API/QuilityAPI.js'
import { debounce } from 'vue-debounce'
export default {
    //name: "QSummitWistiaPlayer",
    //when setting props
    props: {
        video: {
            type: Object,
            default: function() {
                return {
                    video_id: null,
                    title: null,
                    text: null,
                    buttonText: null,
                    buttonHref: null,
                    newWindow: null,
                }
            }
        }
    },
    data: () => ({

    }),
    computed: {
        video_id() {
            return this.video.video_id;
        },
        defaultWistiaVideo() {
            return "https://fast.wistia.net/embed/iframe/" + this.video_id + "?videoFoam=true";
        },
        title() {
            return this.video.title;
        },
        getAlignment: function() {
            return "position:absolute; left:0; bottom:0; padding:20px; text-align:right; width:100%"
        }
    },
    methods: {
        clicked: function(href, newWindow) {
            if (href.indexOf('http') > -1) {
                if (href.indexOf('quility.com') > -1 && newWindow != "_blank") {
                    document.location = href
                } else {
                    window.open(href, newWindow);
                }
            } else {
                this.$router.push(href)
            }
        },
    },
    watch: {

    }
}
</script>